import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=4bd5ef7e&scoped=true"
import script from "./reviewDetail.vue?vue&type=script&lang=js"
export * from "./reviewDetail.vue?vue&type=script&lang=js"
import style0 from "./reviewDetail.vue?vue&type=style&index=0&id=4bd5ef7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd5ef7e",
  null
  
)

export default component.exports